import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';

import { StyledTypography } from './styles';
import { VpHookFormSelect } from '../../../';
import { useFetchPluginOptions } from '../../../../hooks';

export const VpPluginFontFamilySelect = ({ defaultValue, ...rest }) => {
  const { data } = useFetchPluginOptions({ enabled: true });
  const initialValue = defaultValue || data?.fontFamilies?.[0] || '';
  const options = data?.fontFamilies ? (
    data?.fontFamilies.map((font) => (
      <MenuItem key={font} value={font}>
        <StyledTypography fontFamily={font}>{font}</StyledTypography>
      </MenuItem>
    ))
  ) : (
    <MenuItem value=""></MenuItem>
  );

  return (
    <VpHookFormSelect required renderOptions={options} defaultValue={initialValue} {...rest} />
  );
};

VpPluginFontFamilySelect.propTypes = {
  defaultValue: PropTypes.string
};

export default VpPluginFontFamilySelect;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginFontFamilySelect/VpPluginFontFamilySelect.jsx